<template>
  <div>
    <!-- 搜索头部 -->
    <arrorImg bg="white"></arrorImg>
    <div class="search-item">
      <div @click="routeSearch">
        <img src="../../../static/bookCity_search.png" alt="" />
        <span>搜索书名和作者名</span>
      </div>
    </div>
    <navBar title="排行榜" color="#ffffff"></navBar>
    <!-- 左侧排行榜 -->
    <div class="content_class">
      <div class="nav_class">
        <div
          v-for="(item, index) in navList"
          :key="index"
          @click="chooseNav(item)"
        >
          <span :class="item.id == id ? 'active' : ''">{{ item.name }}</span>
        </div>
      </div>
      <div class="sort_class">
         <ul
  v-infinite-scroll="loadMore"
  :infinite-scroll-disabled="loading"
  infinite-scroll-distance="10">
        <li
          v-for="(itemChild, index) in sortList"
          :key="index"
          @click="routeDetail(itemChild)"
        >
          <div class="single-container">
            <img class="single-image" :src="itemChild.bookLogoUrl" alt="" />
            <div class="single-description">
              <div class="single-top">
                <span class="single-title">{{ itemChild.bookName }}</span>
              </div>
              <span class="single-brief">{{ itemChild.bookSummary }}</span>
              <div class="single-bottom">
                <span class="single-author"
                  >{{ itemChild.bookFinish === 0 ? "完结" : "连载" }}
                  {{ itemChild.bookNum }}万字</span
                >
                <span class="sort" v-if="itemChild.category">{{ itemChild.category.split(",")[0] }}</span>
              </div>
            </div>
          </div>
        </li>
         </ul>
        <div class="load-more" >
          <span>{{ !isLoading ?'加载中':loadingText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name:'bookSort',
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      loading:false,
      navList: [], //左边导航数据
      sortList: [], //排行榜数据
      pageNo: 1,
      pageSize: 10,
      id: 0,
      CountPage: 1,
      loadingText: "加载中...",
      isEntranceData: "",
      isLoading:false,
      pageType:''
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }

    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
         var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录
    } else if (isWxAuthorized==0&&city==1 && openid && !this.$store.state.user.isSNS) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getLeaderboard();
      this.insertPageAccessData();
    } else {
      this.getLeaderboard();
      this.insertPageAccessData();
    }
     this.$commonApi.share();
  },
  activated(){
  },
  //  beforeRouteEnter(to, from, next) {
  //   if (from.path == "/"  && to.name == "bookSort" ) {
  //     to.meta.isBack = false;
  //     to.meta.keepAlive = false;
  //   } else {
  //     to.meta.isBack = true;
  //     to.meta.keepAlive = true;
  //   }
  //   console.log(from);
  //   console.log(to);
  //   next();
  // },
   beforeRouteLeave(to, from, next) {
     if(from.name=='bookSort'&&(to.name == "bookDetail"||to.name=='bookSearch')){
      from.meta.isBack = true;
      from.meta.keepAlive = true;
     }else{
        from.meta.isBack = false;
      from.meta.keepAlive = false;
     }
    next();
  },
  methods: {
      loadMore() {
		this.loading = true;
         if (this.CountPage > this.pageNo) {
          this.pageNo += 1;
          this.getLeaderboardBook();
        } else {
          	this.loading = false;
          this.loadingText = "没有更多了";
        }
		},
    insertPageAccessData() {
      var pageType = "";
       if (this.pageType === "bookCharge") {
        pageType = "充值页";
      } else if (this.pageType === "bookCity") {
        pageType = "书城";
      } 
      var params = {
        pageName: "排行榜",
        pageRemark: "上级页面："+pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    getLeaderboard() {
      this.$api.getLeaderboard().then((res) => {
        if (res.status == 1) {
          this.navList = res.data;
          if (res.data.length > 0) {
            this.id = res.data[0].id;
            this.getLeaderboardBook();
          }
        }
      });
    },
    getLeaderboardBook() {
      var params = {
        id: this.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      this.isLoading=false;
      this.$api.getLeaderboardBook(params).then((res) => {
        if (res.status == 1) {
          this.CountPage = res.pages;
          res.data.forEach((item) => {
            var num = (item.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              item.studyingVolume = 999.99;
            } else {
              item.studyingVolume = num;
            }
          });

          if (this.pageNo == 1) {
            this.sortList = res.data;
            if (this.CountPage > 1) {
              this.loadingText = "加载中...";
            } else {
              this.loadingText = "没有更多了";
            }
          } else {
            this.sortList = this.sortList.concat(res.data);
          }
            this.isLoading=true;
        }
      });
    },
    chooseNav(item) {
      this.id = item.id;
      this.pageNo = 1;
      window.scrollTo(0,0)
      this.getLeaderboardBook();
    },
    routeDetail(item) {
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: {
          bookId: item.id,
          pageType: "bookSort",
        },
      });
    },
    routeSearch() {
      this.$router.push({
        path: "/pages/bookSearch/index",
      });
    },
  },
};
</script>

<style scoped>
.search-item {
  padding: 8px 16px;
  border-bottom: 1px solid #f3f3f3;
  position: fixed;
  background-color: #ffffff;
  width: 100%;
  box-sizing: border-box;
  z-index: 99;
   left:0;
}
.search-item {
  top: calc(44px + env(safe-area-inset-top));
}

.search-item > div {
  padding: 6px 12px;
  background-color: #f3f3f3;
  border-radius: 4px;
  display: flex;
}

.search-item img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  margin-top: 2px;
}

.search-item span {
  font-size: 14px;
  color: #aaaaaa;
}

.content_class {
  display: flex;
}

.nav_class {
  margin-right: 24px;
  position: fixed;
  /* left: 0px; */
    margin-top: 88px;
}
.nav_class > div {
  padding: 16px 0px;
}

.nav_class span {
  background-color: #ffffff;
  border-radius: 0 13.5px 13.5px 0;
  color: #666666;
  font-size: 14px;
  padding: 4px 13px;
}

.nav_class .active {
  background-color: #de3b34;
  color: #ffffff;
}
.sort_class {
margin-left:100px;
  margin-top: calc(88px + env(safe-area-inset-top));
      padding-bottom: env(safe-area-inset-bottom);
}
.sort_class li{
  margin-top: 20px;
}
.single-container {
  display: flex;

  justify-content: space-between;
}
.single-image {
  width: 70px;
  height: 92px;
  border-radius: 6px;
}

.single-description {
  width: 160px;
  margin-left:16px;
}

.single-top {
  margin-bottom: 6px;
}

.single-title {
  color: #333333;
  font-weight: bold;
  font-size: 15px;
  font-weight: bold;
  overflow: hidden;
  -webkit-line-clamp: 1;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  line-height: 21px;
    display: -webkit-box;
}

.sort {
  background-color: rgb(253, 245, 233);
  border-radius: 2px;
  font-size: 12px;
  padding: 0px 5px;
  color: #f09b28;
  line-height: 18px;
}

.single-brief {
  font-size: 14px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  color: #666666;
  line-height: 20px;
}
.single-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
}

.single-author {
  font-size: 12px;
  color: #aaaaaa;
  width: 60%;
}
.single-title-right {
  font-size: 12px;
  color: #de3b34;
}
.load-more {
  text-align: center;
  font-size: 12px;
color: #AAAAAA;
   padding: 16px 0px;
  width: 246px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookSort/index.vue